import { Component, OnDestroy, OnInit } from '@angular/core';

import { select, NgRedux } from '@angular-redux/store';

import { PurchaseFacade, ShoppingCartActions, ShoppingCartService, TicketsService } from '@ridango/components';
import { LogService } from '@ridango/core';

import { timer as observableTimer, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AppState } from '../../../app.store';

@Component({
    selector: 'gl-header-shopping-cart-countdown-timer',
    templateUrl: './header-shopping-cart-countdown-timer.component.html',
    styleUrls: ['./header-shopping-cart-countdown-timer.component.scss']
})
export class HeaderShoppingCartCountdownTimerComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();
    @select(['cart', 'docNums']) docNums$;
    @select(['cart', 'countdownTimer']) timeLeft$;
    @select(['cart', 'shopping_cart_id']) cartId$;

    @select(['cart', 'status']) status$;

    timeObservable: Observable<any> = observableTimer(0, 1000);
    sub: any;

    constructor(
        private ngRedux: NgRedux<AppState>,
        private actions: ShoppingCartActions,
        private service: ShoppingCartService,
        private ticketsService: TicketsService,
        private purchaseFacade: PurchaseFacade,
        private ls: LogService
    ) {}

    ngOnInit() {
        this.ls.log(this, 'ngOnInit', '');
        this.status$.pipe(takeUntil(this.componentDestroyed$)).subscribe((s) => {
            this.ls.log(this, 'ngOnInit s', s);
            if (s !== 'S' && s !== 'L' && this.sub) {
                this.ls.log(this, 'ngOnInit', 'this.sub.unsubscribe();');
                this.sub.unsubscribe();
            }
        });
        this.cartId$.pipe(takeUntil(this.componentDestroyed$)).subscribe((cartId) => {
            this.ls.log(this, 'ngOnInit cartid', [
                cartId,
                this.ngRedux.getState().cart.status === 'S' || this.ngRedux.getState().cart.status === 'L'
            ]);
            if (
                cartId &&
                cartId !== '' &&
                cartId !== 0 &&
                (this.ngRedux.getState().cart.status === 'S' || this.ngRedux.getState().cart.status === 'L')
            ) {
                this.ls.log(this, 'ngOnInit should start timer?', cartId);
                this.sub = this.timeObservable.pipe(takeUntil(this.componentDestroyed$)).subscribe(() => {
                    this.ngRedux.dispatch(this.actions.decrementCartTimer());
                });
            } else {
                if (this.sub) {
                    this.ls.log(this, 'ngOnInit else', 'unsbub');
                    this.sub.unsubscribe();
                }
            }
        });

        this.timeLeft$.pipe(takeUntil(this.componentDestroyed$)).subscribe((timer) => {
            if (timer <= 0 && this.sub) {
                this.service.deleteCart();
                this.purchaseFacade.resetWalletPurchase();
                this.ticketsService.setSelectedVoucher(null);
                this.sub.unsubscribe();
            }
        });
    }
    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
